import React from 'react';
import Reflux from 'reflux';
import {Button} from 'antd';
import moment from 'moment';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {openNotice, config} from 'Utils';
import {dmsPurchaseList, getCustomerInvoiceDetail, getCustomerInvoiceList} from '../../service/reportForm';
import {fetchChannelList} from '../../service/home';

class CustomerInvoice extends Reflux.Component {
    constructor(props) {
        super(props);
        this.channelId = window.sessionStorage.getItem('cur_channelId');
        this.state = {
            opts: ['客户开票情况查询（数据2小时刷新）'],
            channelCode: this.channelId,
            key: 0,
            id: '',
            selectedRowKeys: [],
            rows: [],
            total: 1,
            dataSource: [],
            detailTotal: 1,
            channel_type: [],
            gouxiaoUnitList: [],
            searchObj: {
                salesChannelCode: '',
                s: 10,
                p: 1,
                salesUnitId: ''
            },
            loading: false
        };
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
    }

    onSelectChange = (selectedRowKeys) => {
        this.setState({selectedRowKeys});
    }

    goAdd() {
        let param = this.state.searchObj;
        let url = `${config.server}/api/v1/dms/customerInvoice/exportExcel`;
        let urlStr = '';
        Object.keys(param).forEach(item => {
            urlStr += `&${item}=${param[item]}`;
        });
        url += `?${urlStr.substring(1)}`;
        window.open(url);
    }


    advanceReset() {
        let self = this;
        self.setState({
            searchObj: {
                s: 10,
                p: 1,
                salesUnitId: '',
                salesChannelCode: '',
            }, loading: false
        }, function () {
            //self.initData();
        });
    };

    advanceSubmit(form) {
        /* 筛选确认 */
        let self = this;
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                p: 1
            }, loading: true
        }, function () {
            self.initData();
        });
    };

    setFilterParam(name, value) {
        if (name === 'date') {
            this.setState({searchObj: {...this.state.searchObj, startDate: value.from, endDate: value.end}})
        } else {
            if (value == 'ALL') {
                this.setState({searchObj: {...this.state.searchObj, [name]: ''}})
            } else {
                this.setState({searchObj: {...this.state.searchObj, [name]: value}})
            }
        }
    };

    pageChange(page, pageSize) {
        /* 翻页 刷新 */
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}, loading: true}, function () {
            self.initData();
        });
    }

    initData() {
        let searchObj = this.state.searchObj;
        getCustomerInvoiceList(searchObj).then((result) => { //数据列表
            this.setState({
                'rows': result.data || [],
                'total': result.total || 1,
                loading: false
            });
        });
    }

    componentDidMount() {
        let self = this;
        dmsPurchaseList({channelCode: this.state.channelCode, p: 1, s: 100}).then(res => { //购货单位
            if (res.status) {
                let arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                for (let i = 0; i < res.data.length; i++) {
                    let x = res.data[i];
                    arr.push({
                        text: x.name,
                        value: x.id
                    })
                }
                self.setState({gouxiaoUnitList: arr})
            }
        });
        /*渠道类型*/
        fetchChannelList().then(res => { //渠道
            if (res.status) {
                let arr = [];
                res.data.forEach(x => {
                    arr.push({
                        text: x.name,
                        value: x.code
                    })
                });
                self.setState({channel_type: arr},
                )
            }
        });
        //this.initData();
        //设置离开当前路由时的钩子函数
        // this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    render() {
        const {
            opts,
            key,
            rows,
            total,
            dataSource,
            detailTotal,
            searchObj,
            channel_type,
            gouxiaoUnitList,
            selectedRowKeys,
            loading
        } = this.state;
        const filterBoxProps = {
            fileds: [
                {
                    name: 'salesUnitId',
                    label: '购货单位',
                    text: '请选择',
                    type: 'select',
                    showSearch: true,
                    options: gouxiaoUnitList,
                    defaultValue: searchObj.salesUnitId
                }, {
                    name: 'salesChannelCode',
                    label: '渠道',
                    text: '选择渠道',
                    options: channel_type,
                    multiple: false,//支持多选
                    type: 'select',
                    defaultValue: false,
                },
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'rn',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '购货单位',
                    dataIndex: 'salesUnitName',
                }, {
                    title: '期初余额',
                    dataIndex: 'qiChu',
                    render: (text, record, index) => {
                        if (text == 0) {
                            return 0
                        }
                        return <div>{text.toFixed(2) || 0}</div>
                    }
                }, {
                    title: '提前开票订单未发运金额',
                    dataIndex: 'unshipAmount',
                    render: (text, record, index) => {
                        if (text == 0) {
                            return 0
                        }
                        return <div>{text.toFixed(2) || 0}</div>
                    }
                }, {
                    title: '提前开票跨年发运金额',
                    dataIndex: 'lastPreAmount',
                    render: (text, record, index) => {
                        if (text == 0) {
                            return 0
                        }
                        return <div>{text.toFixed(2) || 0}</div>
                    }
                }, {
                    title: '特殊业务金额',
                    dataIndex: 'specialAmount',
                    render: (text, record, index) => {
                        if (text == 0) {
                            return 0
                        }
                        return <div>{text.toFixed(2) || 0}</div>
                    }
                }, {
                    title: '外购销售金额',
                    dataIndex: 'outsideSale',
                    render: (text, record, index) => {
                        if (text == 0) {
                            return 0
                        }
                        return <div>{text.toFixed(2) || 0}</div>
                    }
                }, {
                    title: '发运',
                    dataIndex: 'mon',
                    render: (text, record, index) => {
                        if (text == 0) {
                            return 0
                        }
                        return <div>{text.toFixed(2) || 0}</div>
                    }
                }, {
                    title: '销售折扣金额',
                    dataIndex: 'discountAmount',
                    render: (text, record, index) => {
                        return <div>{text.toFixed(2) || 0}</div>
                    }
                }, {
                    title: '发运调整金额',
                    dataIndex: 'adjustAmount',
                    render: (text, record, index) => {
                        if (text == 0) {
                            return 0
                        }
                        return <div>{text.toFixed(2) || 0}</div>
                    }
                }, {
                    title: '发票折扣折让金额',
                    dataIndex: 'invoiceAmount',
                    render: (text, record, index) => {
                        if (text == 0) {
                            return 0
                        }
                        return <div>{text.toFixed(2) || 0}</div>
                    }
                }, {
                    title: '系统内开票金额',
                    dataIndex: 'allAmount',
                    render: (text, record, index) => {
                        if (text == 0) {
                            return 0
                        }
                        return <div>{text.toFixed(2) || 0}</div>
                    }
                }, {
                    title: '已提交未开票金额',
                    dataIndex: 'noAllAmount',
                    render: (text, record, index) => {
                        if (text == 0) {
                            return 0
                        }
                        return <div>{text.toFixed(2) || 0}</div>
                    }
                }, {
                    title: '系统外开票金额',
                    dataIndex: 'taxAmount',
                    render: (text, record, index) => {
                        if (text == 0) {
                            return 0
                        }
                        return <div>{text.toFixed(2) || 0}</div>
                    }
                }, {
                    title: '提前开票金额',
                    dataIndex: 'preAmount',
                    render: (text, record, index) => {
                        if (text == 0) {
                            return 0
                        }
                        return <div>{text.toFixed(2) || 0}</div>
                    }
                }, {
                    title: '核销金额',
                    dataIndex: 'hxAmount',
                    render: (text, record, index) => {
                        if (text == 0) {
                            return 0
                        }
                        return <div>{text.toFixed(2) || 0}</div>
                    }
                }, {
                    title: '退货保留未开金额',
                    dataIndex: 'uncommitAmount',
                    render: (text, record, index) => {
                        if (text == 0) {
                            return 0
                        }
                        return <div>{text.toFixed(2) || 0}</div>
                    }
                }, {
                    title: '剩余未开金额',
                    dataIndex: 'aAmount',
                    render: (text, record, index) => {
                        if (text == 0) {
                            return 0
                        }
                        return <div>{text.toFixed(2) || 0}</div>
                    }
                }
            ],
            rows
        };
        return <div>
            <DmsTab options={opts} defaultKey={key}/>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew  {...filterBoxProps} />
                </div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head">
                    <Button onClick={this.goAdd.bind(this)} style={{position: 'absolute', bottom: 8, right: 0}}
                            icon="export">导出</Button>
                </div>
                <TableView {...tableViewProps} />
            </div>
        </div>
    }
}
;
export default withRouter(CustomerInvoice);


// WEBPACK FOOTER //
// ./src/routes/reportForm/customerInvoice.js